import VideoHero from "@/components/VideoHero";
import StatsMarquee from "@/components/StatsMarquee";
import ShowReel from "@/components/ShowReel";
import YouTubeFeed from "@/components/YouTubeFeed";
import ProblemSolution from "@/components/ProblemSolution";
import Experience from "@/components/Experience";
import OfferGrid from "@/components/OfferGrid";
import MusicWall from "@/components/MusicWall";
import Testimonials from "@/components/Testimonials";
import EbookRibbon from "@/components/EbookRibbon";
import Founders from "@/components/Founders";
import FAQ from "@/components/FAQ";
import CTABand from "@/components/CTABand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <VideoHero />
      <StatsMarquee />
      <ShowReel />
      <YouTubeFeed />
      <ProblemSolution />
      <Experience />
      <OfferGrid />
      <MusicWall />
      <Testimonials />
      <EbookRibbon />
      <Founders />
      <FAQ />
      <CTABand />
    </div>
  );
}
